import { tns } from 'tiny-slider/src/tiny-slider'

class HeroCarousel {
    constructor(element) {
        if (!element) return

        this.element = element

        this._iniCarousel()

        this.setImgHeightVar()
        this.setCarouselHeight()

        window.addEventListener('resize', () => {
            this.setImgHeightVar()
            this.setCarouselHeight()
        })
    }

    _iniCarousel() {
        this.carouselElem = this.element.querySelector('.s-hero-carousel__items')
        this.carouselNav = this.element.querySelector('.s-hero-carousel__nav')
        this.currentSlideElem = this.carouselNav.querySelector('.s-hero-carousel__nav .current')
        this.totalSlidesElem = this.carouselNav.querySelector('.s-hero-carousel__nav .total')

        this.autoplayTimer = 0

        this.carousel = tns({
            container: this.carouselElem,
            mode: 'gallery',
            items: 1,
            slideBy: 1,
            nav: false,
            mouseDrag: false,
            loop: true,
            speed: 500,
            controlsText: ['', ''],
            edgePadding: 0,
            gutter: 0,
        })

        const carouselInfo = this.carousel.getInfo()

        if (carouselInfo.slideCount === 1) {
            this.element.classList.add('no-controls')
            return
        }

        this.currentSlideElem.innerHTML = this.formatIndex(carouselInfo.displayIndex)
        this.totalSlidesElem.innerHTML = this.formatIndex(carouselInfo.slideCount)

        this.setAutoplay()

        this.carousel.events.on('indexChanged', () => {
            const carouselInfo = this.carousel.getInfo()
            this.currentSlideElem.innerHTML = this.formatIndex(carouselInfo.displayIndex)
            this.setAutoplay()
        })
    }

    formatIndex(index) {
        return index < 10 ? `0${index}` : index
    }

    setAutoplay() {
        clearTimeout(this.autoplayTimer)

        this.autoplayTimer = setTimeout(() => {
            this.carousel.goTo('next')
        }, 6000)
    }

    setImgHeightVar() {
        const slideImg = this.element.querySelector('.s-hero-carousel__img')
        this.element.style.setProperty('--mob-img-height', `${slideImg.clientHeight}px`)
    }

    setCarouselHeight() {
        let height = 0

        this.element.querySelectorAll('.s-hero-carousel__item').forEach((item) => {
            height = Math.max(height, item.clientHeight)
        })

        this.element.style.height = `${height}px`
    }
}

export default HeroCarousel
